/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContractSignerStatus = {
  type: 'Enum',
} as const;
